import {
  ADD_PARTICIPANTS_INVITES,
  EDIT_PARTICIPANTS_INVITES,
  LIST_PARTICIPANTS_INVITES,
  VIEW_PARTICIPANTS_INVITES,
  DELETE_PARTICIPANTS_INVITES,
  ADD_PARTICIPANTS_INVITES_TEXT,
  EDIT_PARTICIPANTS_INVITES_TEXT,
  LIST_PARTICIPANTS_INVITES_TEXT,
  VIEW_PARTICIPANTS_INVITES_TEXT,
  DELETE_PARTICIPANTS_INVITES_TEXT,
  PARTICIPANTS_INVITES_SUCCESS,
  PARTICIPANTS_INVITES_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const PartcipantsInvites = (state = initialState, action) => {
  switch (action.type) {

    // add Invites
    case ADD_PARTICIPANTS_INVITES:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
   
      }
      break
    case PARTICIPANTS_INVITES_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading: false,

      }
      break
    case PARTICIPANTS_INVITES_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit Invites
    case EDIT_PARTICIPANTS_INVITES:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list Invites
    case LIST_PARTICIPANTS_INVITES:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view Invites
    case VIEW_PARTICIPANTS_INVITES:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete Invites
    case DELETE_PARTICIPANTS_INVITES:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add Invites
    case ADD_PARTICIPANTS_INVITES_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case PARTICIPANTS_INVITES_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case PARTICIPANTS_INVITES_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit Invites
    case EDIT_PARTICIPANTS_INVITES_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list Invites
    case LIST_PARTICIPANTS_INVITES_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view Invites
    case VIEW_PARTICIPANTS_INVITES_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete Invites
    case DELETE_PARTICIPANTS_INVITES_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default PartcipantsInvites
